import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './service/store';
import { BrowserRouter } from "react-router-dom";
import { createTheme, MantineProvider } from '@mantine/core';
import '@mantine/core/styles.layer.css';
import './vendor/mantine-datatable/styles.layer.css';

const theme = createTheme({
  primaryColor: 'blue',
  components: {
    Button: {
      defaultProps: {
        className: 'bg-[color:var(--app-primaryBlue-color)] rounded-lg md:text-sm text-xs text-white font-semibold pl-4 pr-4 pt-2 pb-2',
      },
    },
    Input: {
      defaultProps: {
        variant: 'default',
      },
      styles: {
        input: {
          backgroundColor: '#ffffff',
          color: '#000000',
          borderColor: '#dee2e6',
        },
      },
    },
    TextInput: {
      styles: {
        input: {
          backgroundColor: '#ffffff',
          color: '#000000',
          borderColor: '#dee2e6',
        },
      },
    },
    Select: {
      styles: {
        input: {
          backgroundColor: '#ffffff',
          color: '#000000',
          borderColor: '#dee2e6',
        },
      },
    },
  },
});

// Suppress benign ResizeObserver loop error (triggered by Mantine MultiSelect resizing)
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <MantineProvider theme={theme} defaultColorScheme="light" forceColorScheme="light">
          <App />
        </MantineProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
